import { RadioInput } from '__legacy__/components/RadioInput';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ResolveConflictDecision } from '../../../../models/ImportAnnotationsConflicts';

interface IProps {
  imageName: string;
  decision: ResolveConflictDecision;
  onKeepOriginal: () => void;
  onReplaceAnnotation: () => void;
}

export const ResolveConflictTile = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { imageName, decision, onKeepOriginal, onReplaceAnnotation } = props;
  return (
    <div className='resolve-conflict'>
      <p
        className='resolve-conflict-header'
        title={imageName}
      >
        {imageName}
      </p>
      <div className='resolve-conflict-options'>
        <RadioInput
          label={t('new.projects.details.import_annotations.steps.resolve_conflicts.keep_original')}
          id={`keep-original-${imageName}`}
          checked={decision === ResolveConflictDecision.keepOriginal}
          onClick={onKeepOriginal}
        />
        <RadioInput
          label={t('new.projects.details.import_annotations.steps.resolve_conflicts.replace_annotation')}
          id={`replace-annotation-${imageName}`}
          checked={decision === ResolveConflictDecision.replaceAnnotation}
          onClick={onReplaceAnnotation}
        />
      </div>
      <hr />
    </div>
  );
});
